import {
  ApiResponse,
  NetPriceCeilingGrouped,
  CreateDiscount,
  TokenData,
  CashDiscount,
  OtpResponse,
  CreateDiscountLimits,
  CreateNetPriceCeiling,
  NetPriceCeiling,
  UpdateNetPriceCeiling,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class NetPriceCeilingService extends ApiService {
  public async loadNetPriceCeiling() {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling/list`;

    const resposne = await http.get<ApiResponse<NetPriceCeilingGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async create(data: CreateNetPriceCeiling) {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async update(data: CreateNetPriceCeiling, id: string) {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async updateVehicleNPC(data: UpdateNetPriceCeiling, id: string) {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling/${id}/ceiling-prices`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async get(id: string) {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling/${id}`;

    const resposne = await http.get<ApiResponse<NetPriceCeiling>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
}
